(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-motion"] && !Shopify.designMode) return;
  try {
    (function () {
    function whenGsapReady(callback, attempt) {
      attempt = attempt || 0;
      if (window.gsap && window.ScrollTrigger) {
        callback();
        return;
      }
      if (attempt > 40) return;
      setTimeout(function () {
        whenGsapReady(callback, attempt + 1);
      }, 100);
    }

    function initScrollMotion() {
      var gsap = window.gsap;
      var ScrollTrigger = window.ScrollTrigger;
      gsap.registerPlugin(ScrollTrigger);

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      document.querySelectorAll('[data-animate-rise]').forEach(function (el) {
        if (reduceMotion) return;
        gsap.from(el, {
          opacity: 0,
          y: 26,
          duration: 0.9,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 88%',
            once: true,
          },
        });
      });

      if (!reduceMotion) {
        document.querySelectorAll('[data-parallax]').forEach(function (el) {
          var distance = parseFloat(el.getAttribute('data-parallax')) || -40;
          gsap.to(el, {
            y: distance,
            ease: 'none',
            scrollTrigger: {
              trigger: el,
              start: 'top bottom',
              end: 'bottom top',
              scrub: true,
            },
          });
        });
      }

      document.querySelectorAll('[data-scroll-shadow]').forEach(function (el) {
        ScrollTrigger.create({
          trigger: document.body,
          start: '60px top',
          toggleClass: { targets: el, className: 'is-scrolled' },
        });
      });

      ScrollTrigger.refresh();

      // The theme editor re-renders section markup in place; refresh trigger
      // positions so they still line up with the new layout.
      document.addEventListener('shopify:section:load', function () {
        ScrollTrigger.refresh();
      });
    }

    if (document.readyState === 'complete') {
      whenGsapReady(initScrollMotion);
    } else {
      window.addEventListener('load', function () {
        whenGsapReady(initScrollMotion);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
